import createReactComponent from '../createReactComponent';
var CloudSnow = createReactComponent('CloudSnow', [['path', {
  d: 'M20 16.2A4.5 4.5 0 0017.5 8h-1.8A7 7 0 104 14.9',
  key: '1fiucv'
}], ['path', {
  d: 'M8 15h0',
  key: 'q9eq1f'
}], ['path', {
  d: 'M8 19h0',
  key: 'alrq73'
}], ['path', {
  d: 'M12 17h0',
  key: 'sk4dwq'
}], ['path', {
  d: 'M12 21h0',
  key: 'qmeo1b'
}], ['path', {
  d: 'M16 15h0',
  key: 'pzrbjg'
}], ['path', {
  d: 'M16 19h0',
  key: '1lbn4w'
}]]);
export default CloudSnow;